// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LobbyVision2LiftNumSource } from "./lobby-vision2-lift-num-source";
import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { CallType } from "../lobby-vision2/call-type";
import { Direction } from "../lobby-vision2/direction";
import { FrameType } from "../lobby-vision2/frame-type";
import { OperationType } from "../lobby-vision2/operation-type";

/**
 * Config-time LV2 inbound mapping: telegraph(response) to LN2 message.
 *
 * Bank/lift-agnostic. Telegraph `bank_num`/`lift_num` are NOT stored here —
 * they are DERIVED at expansion time from `bank.logical_port` plus per-car index.
 */
export class LobbyVision2ReadEntry implements flatbuffers.IUnpackableObject<LobbyVision2ReadEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LobbyVision2ReadEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLobbyVision2ReadEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2ReadEntry,
  ): LobbyVision2ReadEntry {
    return (obj || new LobbyVision2ReadEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsLobbyVision2ReadEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: LobbyVision2ReadEntry,
  ): LobbyVision2ReadEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LobbyVision2ReadEntry()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  telegraphType(): FrameType {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : FrameType.unknown;
  }

  operationId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  operationType(): OperationType {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : OperationType.unknown0;
  }

  data(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  ln2Message(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  floorsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  unitsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  bankLevel(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  individual(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  pairedLn2Message(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Per-row lift_num source, used ONLY when `individual` = true. When
   * `individual` = false this field is ignored and the adapter-level
   * `LobbyVision2AddressingConfig.lift_num_source` governs. Default IndexBased so
   * an individual row with no explicit choice behaves like classic index
   * addressing. Reuses the existing enum — no new enum. Appended at end of table
   * for `FlatBuffer` wire compatibility.
   */
  liftNumSourceOverride(): LobbyVision2LiftNumSource {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LobbyVision2LiftNumSource.IndexBased;
  }

  /**
   * Per-row base added to `car_index` when `lift_num_source_override` = `IndexBased`
   * (only meaningful when `individual` = true). Mirrors
   * `LobbyVision2AddressingConfig.lift_num_base` (default 1). Appended at end of
   * table for `FlatBuffer` wire compatibility.
   */
  liftNumBaseOverride(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 1;
  }

  /**
   * Secure car call type (front/rear/handicap variants). Carries call-type
   * info separately from `data` so `data` is free to carry floor when
   * `floors_based` is set. Appended at end of table for `FlatBuffer` wire
   * compatibility.
   */
  ccType(): CallType {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : CallType.unknown;
  }

  /**
   * Allocated hall call direction. Carries direction separately from `data`
   * for the same reason as `cc_type`. Appended at end of table for `FlatBuffer`
   * wire compatibility.
   */
  allocType(): Direction {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Direction.idle;
  }

  static startLobbyVision2ReadEntry(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addTelegraphType(builder: flatbuffers.Builder, telegraphType: FrameType) {
    builder.addFieldInt8(0, telegraphType, FrameType.unknown);
  }

  static addOperationId(builder: flatbuffers.Builder, operationId: number) {
    builder.addFieldInt16(1, operationId, 0);
  }

  static addOperationType(builder: flatbuffers.Builder, operationType: OperationType) {
    builder.addFieldInt8(2, operationType, OperationType.unknown0);
  }

  static addData(builder: flatbuffers.Builder, data: number) {
    builder.addFieldInt8(3, data, 0);
  }

  static addLn2Message(builder: flatbuffers.Builder, ln2MessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, ln2MessageOffset, 0);
  }

  static addFloorsBased(builder: flatbuffers.Builder, floorsBased: boolean) {
    builder.addFieldInt8(5, +floorsBased, +false);
  }

  static addUnitsBased(builder: flatbuffers.Builder, unitsBased: boolean) {
    builder.addFieldInt8(6, +unitsBased, +false);
  }

  static addBankLevel(builder: flatbuffers.Builder, bankLevel: boolean) {
    builder.addFieldInt8(7, +bankLevel, +false);
  }

  static addIndividual(builder: flatbuffers.Builder, individual: boolean) {
    builder.addFieldInt8(8, +individual, +false);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, labelOffset, 0);
  }

  static addPairedLn2Message(
    builder: flatbuffers.Builder,
    pairedLn2MessageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, pairedLn2MessageOffset, 0);
  }

  static addLiftNumSourceOverride(
    builder: flatbuffers.Builder,
    liftNumSourceOverride: LobbyVision2LiftNumSource,
  ) {
    builder.addFieldInt8(11, liftNumSourceOverride, LobbyVision2LiftNumSource.IndexBased);
  }

  static addLiftNumBaseOverride(builder: flatbuffers.Builder, liftNumBaseOverride: number) {
    builder.addFieldInt8(12, liftNumBaseOverride, 1);
  }

  static addCcType(builder: flatbuffers.Builder, ccType: CallType) {
    builder.addFieldInt16(13, ccType, CallType.unknown);
  }

  static addAllocType(builder: flatbuffers.Builder, allocType: Direction) {
    builder.addFieldInt8(14, allocType, Direction.idle);
  }

  static endLobbyVision2ReadEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): LobbyVision2ReadEntryT {
    return new LobbyVision2ReadEntryT(
      this.telegraphType(),
      this.operationId(),
      this.operationType(),
      this.data(),
      this.ln2Message() !== null ? this.ln2Message()!.unpack() : null,
      this.floorsBased(),
      this.unitsBased(),
      this.bankLevel(),
      this.individual(),
      this.label(),
      this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null,
      this.liftNumSourceOverride(),
      this.liftNumBaseOverride(),
      this.ccType(),
      this.allocType(),
    );
  }

  unpackTo(_o: LobbyVision2ReadEntryT): void {
    _o.telegraphType = this.telegraphType();
    _o.operationId = this.operationId();
    _o.operationType = this.operationType();
    _o.data = this.data();
    _o.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    _o.floorsBased = this.floorsBased();
    _o.unitsBased = this.unitsBased();
    _o.bankLevel = this.bankLevel();
    _o.individual = this.individual();
    _o.label = this.label();
    _o.pairedLn2Message =
      this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null;
    _o.liftNumSourceOverride = this.liftNumSourceOverride();
    _o.liftNumBaseOverride = this.liftNumBaseOverride();
    _o.ccType = this.ccType();
    _o.allocType = this.allocType();
  }

  unpackFields(...fields: string[]): LobbyVision2ReadEntryT {
    const t = new LobbyVision2ReadEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("telegraph_type")) {
      t.telegraphType = this.telegraphType();
    }
    if (fieldSet.has("operation_id")) {
      t.operationId = this.operationId();
    }
    if (fieldSet.has("operation_type")) {
      t.operationType = this.operationType();
    }
    if (fieldSet.has("data")) {
      t.data = this.data();
    }
    if (fieldSet.has("ln2_message")) {
      t.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    }
    if (fieldSet.has("floors_based")) {
      t.floorsBased = this.floorsBased();
    }
    if (fieldSet.has("units_based")) {
      t.unitsBased = this.unitsBased();
    }
    if (fieldSet.has("bank_level")) {
      t.bankLevel = this.bankLevel();
    }
    if (fieldSet.has("individual")) {
      t.individual = this.individual();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    if (fieldSet.has("paired_ln2_message")) {
      t.pairedLn2Message =
        this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null;
    }
    if (fieldSet.has("lift_num_source_override")) {
      t.liftNumSourceOverride = this.liftNumSourceOverride();
    }
    if (fieldSet.has("lift_num_base_override")) {
      t.liftNumBaseOverride = this.liftNumBaseOverride();
    }
    if (fieldSet.has("cc_type")) {
      t.ccType = this.ccType();
    }
    if (fieldSet.has("alloc_type")) {
      t.allocType = this.allocType();
    }
    return t;
  }
}

export class LobbyVision2ReadEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public telegraphType: FrameType = FrameType.unknown,
    public operationId: number = 0,
    public operationType: OperationType = OperationType.unknown0,
    public data: number = 0,
    public ln2Message: ValuedMessageT | null = null,
    public floorsBased: boolean = false,
    public unitsBased: boolean = false,
    public bankLevel: boolean = false,
    public individual: boolean = false,
    public label: string | Uint8Array | null = null,
    public pairedLn2Message: ValuedMessageT | null = null,
    public liftNumSourceOverride: LobbyVision2LiftNumSource = LobbyVision2LiftNumSource.IndexBased,
    public liftNumBaseOverride: number = 1,
    public ccType: CallType = CallType.unknown,
    public allocType: Direction = Direction.idle,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const ln2Message = this.ln2Message !== null ? this.ln2Message!.pack(builder) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;
    const pairedLn2Message =
      this.pairedLn2Message !== null ? this.pairedLn2Message!.pack(builder) : 0;

    LobbyVision2ReadEntry.startLobbyVision2ReadEntry(builder);
    LobbyVision2ReadEntry.addTelegraphType(builder, this.telegraphType);
    LobbyVision2ReadEntry.addOperationId(builder, this.operationId);
    LobbyVision2ReadEntry.addOperationType(builder, this.operationType);
    LobbyVision2ReadEntry.addData(builder, this.data);
    LobbyVision2ReadEntry.addLn2Message(builder, ln2Message);
    LobbyVision2ReadEntry.addFloorsBased(builder, this.floorsBased);
    LobbyVision2ReadEntry.addUnitsBased(builder, this.unitsBased);
    LobbyVision2ReadEntry.addBankLevel(builder, this.bankLevel);
    LobbyVision2ReadEntry.addIndividual(builder, this.individual);
    LobbyVision2ReadEntry.addLabel(builder, label);
    LobbyVision2ReadEntry.addPairedLn2Message(builder, pairedLn2Message);
    LobbyVision2ReadEntry.addLiftNumSourceOverride(builder, this.liftNumSourceOverride);
    LobbyVision2ReadEntry.addLiftNumBaseOverride(builder, this.liftNumBaseOverride);
    LobbyVision2ReadEntry.addCcType(builder, this.ccType);
    LobbyVision2ReadEntry.addAllocType(builder, this.allocType);

    return LobbyVision2ReadEntry.endLobbyVision2ReadEntry(builder);
  }

  clone(): LobbyVision2ReadEntryT {
    const obj = new LobbyVision2ReadEntryT();
    obj.telegraphType = this.telegraphType;
    obj.operationId = this.operationId;
    obj.operationType = this.operationType;
    obj.data = this.data;
    obj.ln2Message = this.ln2Message !== null ? this.ln2Message!.clone() : null;
    obj.floorsBased = this.floorsBased;
    obj.unitsBased = this.unitsBased;
    obj.bankLevel = this.bankLevel;
    obj.individual = this.individual;
    obj.label = this.label;
    obj.pairedLn2Message = this.pairedLn2Message !== null ? this.pairedLn2Message!.clone() : null;
    obj.liftNumSourceOverride = this.liftNumSourceOverride;
    obj.liftNumBaseOverride = this.liftNumBaseOverride;
    obj.ccType = this.ccType;
    obj.allocType = this.allocType;
    return obj;
  }

  equals(other: LobbyVision2ReadEntryT): boolean {
    if (this.telegraphType !== other.telegraphType) return false;
    if (this.operationId !== other.operationId) return false;
    if (this.operationType !== other.operationType) return false;
    if (this.data !== other.data) return false;
    if (this.ln2Message !== null && other.ln2Message !== null) {
      if (!this.ln2Message!.equals(other.ln2Message!)) return false;
    } else if (this.ln2Message !== other.ln2Message) return false;
    if (this.floorsBased !== other.floorsBased) return false;
    if (this.unitsBased !== other.unitsBased) return false;
    if (this.bankLevel !== other.bankLevel) return false;
    if (this.individual !== other.individual) return false;
    if (this.label !== other.label) return false;
    if (this.pairedLn2Message !== null && other.pairedLn2Message !== null) {
      if (!this.pairedLn2Message!.equals(other.pairedLn2Message!)) return false;
    } else if (this.pairedLn2Message !== other.pairedLn2Message) return false;
    if (this.liftNumSourceOverride !== other.liftNumSourceOverride) return false;
    if (this.liftNumBaseOverride !== other.liftNumBaseOverride) return false;
    if (this.ccType !== other.ccType) return false;
    if (this.allocType !== other.allocType) return false;
    return true;
  }
}

export function verifyLobbyVision2ReadEntry(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkScalarField(tablePos, 6, 2);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 12);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 24);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkScalarField(tablePos, 28, 1);
    verifier.checkScalarField(tablePos, 30, 2);
    verifier.checkScalarField(tablePos, 32, 1);
  } finally {
    verifier.popDepth();
  }
}
